import React from 'react';
import styled from 'styled-components';

const QuickActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  max-width: 75%;
`;

const ActionButton = styled.button`
  background: white;
  border: 2px solid #275386;
  color: #275386;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #275386;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(39, 83, 134, 0.3);
  }
`;

const QuickActions = ({ actions, onActionClick }) => {
  if (!actions || actions.length === 0) return null;

  return (
    <QuickActionsContainer>
      {actions.map((action, index) => (
        <ActionButton 
          key={index}
          onClick={() => onActionClick(action)}
        >
          {action}
        </ActionButton>
      ))}
    </QuickActionsContainer>
  );
};

export default QuickActions; 